import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/logo/adtech-logo-black.svg")